import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'createExceptionToggle', 'exceptionSection', 'exceptionMode', 'customRange']

  connect() {
    if (this.hasCreateExceptionToggleTarget) this.toggleException();
    if (this.hasCustomRangeTarget) this.toggleMode();
  }

  toggleForm() {
    const hidden = this.formTarget.classList.toggle('hidden');
    if (!hidden) this.formTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  toggleException() {
    this.exceptionSectionTarget.classList.toggle('hidden', !this.createExceptionToggleTarget.checked);
  }

  toggleMode() {
    const selected = this.exceptionModeTargets.find((radio) => radio.checked);
    this.customRangeTarget.classList.toggle('hidden', selected?.value !== 'custom');
  }
}
